// This file was autogenerated from /frontend/sail-next/packages/docs/src/component-examples/BarChart/index.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';

import {Basic} from './basic.story';
import {Color} from './color.story';

const basic = {
  rendered: <Basic />,
  source: `const sales = [{
  date: 'Jan',
  sold: 1
}, {
  date: 'Feb',
  sold: 4
}, {
  date: 'Mar',
  sold: 2
}, {
  date: 'Apr',
  sold: 3
}];

<BarChart data={sales} x="date" y="sold" />`,
};

const color = {
  rendered: <Color />,
  source: `const sales = [{
  date: 'Jan',
  sold: 1,
  product: 'tables'
}, {
  date: 'Feb',
  sold: 4,
  product: 'tables'
}, {
  date: 'Mar',
  sold: 2,
  product: 'tables'
}, {
  date: 'Apr',
  sold: 3,
  product: 'tables'
}, {
  date: 'May',
  sold: 2,
  product: 'chairs'
}, {
  date: 'Jun',
  sold: 6,
  product: 'chairs'
}, {
  date: 'Jul',
  sold: 4,
  product: 'chairs'
}, {
  date: 'Aug',
  sold: 1,
  product: 'chairs'
}];

<BarChart data={sales} x="date" y="sold" color="product" />`,
};

export const BarChartExamples = {
  basic,
  color,
};
